
export const toolIcons = {
    "React": ['fab', 'react'],
    "TypeScript": ['fab', 'js'],
    "SpringBoot": ['fas', 'leaf'],
    "Next.js": ['fab', 'js-square'],
    "Tailwind CSS": ['fab', 'css3-alt'],
    "Framer Motion": ['fas', 'code'],
    "Sanity CMS": ['fas', 'database'],
    "Auth.js": ['fas', 'shield-alt'],
    "Markdown": ['fab', 'markdown'],
    "GROQ": ['fas', 'search'],
    "Sentry": ['fas', 'bug'],
    "Node.js": ['fab', 'node-js'],
    "Express.js": ['fas', 'server'],
    "MongoDB": ['fas', 'database'],
    "PostgreSQL": ['fas', 'database'],
    "GraphQL": ['fas', 'project-diagram'],
    "Apollo": ['fas', 'rocket'],
    "Docker": ['fab', 'docker'],
    "Kubernetes": ['fas', 'cubes'],
    "AWS": ['fab', 'aws'],
    "Azure": ['fab', 'microsoft'],
    "Google Cloud": ['fab', 'google'],
    "Firebase": ['fas', 'fire'],
    "Git": ['fab', 'git'],
    "GitHub": ['fab', 'github'],
    "GitLab": ['fab', 'gitlab'],
    "Vue.js": ['fab', 'vuejs'],
    "Angular": ['fab', 'angular'],
    "Svelte": ['fab', 'svelte'],
    "Python": ['fab', 'python'],
    "Django": ['fas', 'leaf'],
    "Flask": ['fas', 'flask'],
    "Ruby on Rails": ['fas', 'gem'],
    "PHP": ['fab', 'php'],
    "Laravel": ['fab', 'laravel'],
    "Java": ['fab', 'java'],
    "Kotlin": ['fas', 'code'],
    "Swift": ['fab', 'swift'],
    "Go": ['fab', 'golang'],
    "Rust": ['fas', 'cog'],
    "C++": ['fas', 'code'],
    "C#": ['fab', 'microsoft'],
    ".NET": ['fab', 'microsoft'],
    "TensorFlow": ['fas', 'brain'],
    "PyTorch": ['fas', 'brain'],
    "Pandas": ['fas', 'table'],
    "NumPy": ['fas', 'calculator'],
    "Matplotlib": ['fas', 'chart-line'],
    "Jupyter": ['fas', 'book'],
    "R": ['fab', 'r-project'],
    "Bootstrap": ['fab', 'bootstrap'],
    "Material-UI": ['fab', 'material-ui'],
    "Chakra UI": ['fas', 'paint-brush'],
    "Sass": ['fab', 'sass'],
    "Less": ['fab', 'less'],
    "Webpack": ['fas', 'cube'],
    "Babel": ['fas', 'exchange-alt'],
    "Jest": ['fas', 'vial'],
    "Cypress": ['fas', 'bug'],
    "Storybook": ['fas', 'book'],
    "Figma": ['fab', 'figma'],
    "Sketch": ['fab', 'sketch'],
    "Adobe XD": ['fab', 'adobe'],
    "InVision": ['fas', 'pencil-ruler'],
    "Zeplin": ['fas', 'ruler'],
    "Postman": ['fas', 'paper-plane'],
    "Swagger": ['fas', 'file-code'],
    "Jira": ['fab', 'jira'],
    "Trello": ['fab', 'trello'],
    "Slack": ['fab', 'slack'],
    "Discord": ['fab', 'discord'],
    "Zoom": ['fas', 'video'],
    "VS Code": ['fas', 'code'],
    "IntelliJ IDEA": ['fas', 'code'],
    "Eclipse": ['fas', 'code'],
    "Xcode": ['fas', 'apple'],
    "Android Studio": ['fab', 'android'],
    "Unity": ['fas', 'gamepad'],
    "Unreal Engine": ['fas', 'gamepad'],
    "Blender": ['fas', 'cube'],
    "Photoshop": ['fab', 'adobe'],
    "Illustrator": ['fab', 'adobe'],
    "Premiere Pro": ['fab', 'adobe'],
    "After Effects": ['fab', 'adobe'],
    "Javascript": ['fab', 'js'],
    "HTML": ['fab', 'html5'],
    "CSS": ['fab', 'css3-alt'],
    "RaspberryPi": ['fab', 'raspberry-pi'],
    "SQL": ['fas', 'database'],
    "Auth0": ['fas', 'lock']
};

export const getToolIconColor = (tool) => {
    const colors = {
        "React": "#61DAFB",
        "TypeScript": "#3178C6",
        "SpringBoot": "#6DB33F",
        "Next.js": "#000000",
        "Tailwind CSS": "#38B2AC",
        "Framer Motion": "#E10098",
        "Sanity CMS": "#F03E2F",
        "Auth.js": "#00796B",
        "Markdown": "#000000",
        "GROQ": "#FF4088",
        "Sentry": "#FB4226",
        "Node.js": "#339933",
        "Express.js": "#000000",
        "MongoDB": "#47A248",
        "PostgreSQL": "#336791",
        "GraphQL": "#E10098",
        "Apollo": "#311C87",
        "Docker": "#2496ED",
        "Kubernetes": "#326CE5",
        "AWS": "#FF9900",
        "Azure": "#0078D4",
        "Google Cloud": "#4285F4",
        "Firebase": "#FFCA28",
        "Git": "#F05032",
        "GitHub": "#181717",
        "GitLab": "#FC6D26",
        "Vue.js": "#4FC08D",
        "Angular": "#DD0031",
        "Svelte": "#FF3E00",
        "Python": "#3776AB",
        "Django": "#092E20",
        "Flask": "#000000",
        "Ruby on Rails": "#CC0000",
        "PHP": "#777BB4",
        "Laravel": "#FF2D20",
        "Java": "#007396",
        "Kotlin": "#0095D5",
        "Swift": "#FA7343",
        "Go": "#00ADD8",
        "Rust": "#000000",
        "C++": "#00599C",
        "C#": "#239120",
        ".NET": "#512BD4",
        "TensorFlow": "#FF6F00",
        "PyTorch": "#EE4C2C",
        "Pandas": "#150458",
        "NumPy": "#013243",
        "Matplotlib": "#11557C",
        "Jupyter": "#F37626",
        "R": "#276DC3",
        "Bootstrap": "#7952B3",
        "Material-UI": "#0081CB",
        "Chakra UI": "#319795",
        "Sass": "#CC6699",
        "Less": "#1D365D",
        "Webpack": "#8DD6F9",
        "Babel": "#F9DC3E",
        "Jest": "#C21325",
        "Cypress": "#17202C",
        "Storybook": "#FF4785",
        "Figma": "#F24E1E",
        "Zeplin": "#F7B500",
        "Postman": "#FF6C37",
        "VS Code": "#007ACC",
        "IntelliJ IDEA": "#000000",
        "Eclipse": "#2C2255",
        "Xcode": "#147EFB",
        "Android Studio": "#3DDC84",
        "Unity": "#000000",
        "Unreal Engine": "#313131",
        "Blender": "#F5792A",
        "Photoshop": "#31A8FF",
        "Illustrator": "#FF9A00",
        "Premiere Pro": "#9999FF",
        "After Effects": "#9999FF",
        "Javascript": "#F7DF1E",
        "HTML": "#E34F26",
        "CSS": "#1572B6",
        "RaspberryPi": "#C51A4A",
        "SQL": "#CC2927",
        "Auth0": "#EB5424"
    };
    return colors[tool] || "#FFFFFF";
};
